import React, { useState } from 'react';
import SongItem from '../SongItem/SongItem'
import SongItemWrapper from '../SongItemWrapper/SongItemWrapper'
import { Row, Col } from 'reactstrap';
import { isMobile } from 'react-device-detect';

const SongListForDownload = (props) => {
    const [limit, setLimit] = useState(7);

    const onLoadMore = () => {
        setLimit(limit + 7);
    }

    return (
        <div className='song-list-for-download' >

            <Row>
                {props.items.slice(0, limit).map((item, i) => (
                    <Col key={i} xs={isMobile ? 12 : 4} sm={isMobile ? 12 : 4} md={isMobile ? 12 : 4}>
                        <div className="item-container">
                            <SongItemWrapper audio={item} isDownloadMode={true} isPlaylistMode={false}  songId={item.productId}  >
                                <SongItem isDisplayPlayer={true} playerSize={87} isDetailsFromLeft={true} audio={item} onClickSong={()=> {}} ></SongItem>
                            </SongItemWrapper>
                            {isMobile ? <div className="sparator"></div> : null}
                        </div>
                    </Col>
                ))}
            </Row>

            <div className="load-more" ><a href="#" onClick={onLoadMore} >טען עוד</a></div>

        </div>
    );
};

export default SongListForDownload;
